(function () {
  var grid = document.querySelector('[data-vg-blog-grid]');
  if (!grid) return;
 
  var KEY = 'vg_blog_favs';
 
  function getFavs() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function setFavs(favs) {
    try { localStorage.setItem(KEY, JSON.stringify(favs)); } catch (e) {}
  }
 
  var favFilterBtn = document.querySelector('[data-fav-filter]');
  var favCountEl = document.querySelector('[data-fav-count]');
  var favEmpty = document.querySelector('[data-fav-empty]');
  var filtering = false;
 
  function refresh() {
    var favs = getFavs();
    var visibleFavs = 0;
    grid.querySelectorAll('[data-vg-card]').forEach(function (card) {
      var id = card.getAttribute('data-article-id');
      var isFav = favs.indexOf(id) !== -1;
      card.classList.toggle('is-fav', isFav);
      var btn = card.querySelector('[data-fav-btn]');
      if (btn) btn.setAttribute('aria-pressed', String(isFav));
      card.hidden = filtering && !isFav;
      if (isFav) visibleFavs++;
    });
    if (favCountEl) favCountEl.textContent = String(favs.length);
    if (favEmpty) favEmpty.hidden = !(filtering && visibleFavs === 0);
    if (favFilterBtn) {
      favFilterBtn.setAttribute('aria-pressed', String(filtering));
      favFilterBtn.classList.toggle('is-active', filtering);
    }
  }
 
  grid.addEventListener('click', function (e) {
    var favBtn = e.target.closest('[data-fav-btn]');
    if (favBtn) {
      var card = favBtn.closest('[data-vg-card]');
      var id = card.getAttribute('data-article-id');
      var favs = getFavs();
      var i = favs.indexOf(id);
      if (i === -1) { favs.push(id); } else { favs.splice(i, 1); }
      setFavs(favs);
      refresh();
      return;
    }
 
    var copyBtn = e.target.closest('[data-copy-btn]');
    if (copyBtn) {
      var url = copyBtn.getAttribute('data-url');
      var done = function () {
        copyBtn.classList.add('is-copied');
        var label = copyBtn.querySelector('.vg-card__copy-label');
        var orig = label ? label.textContent : '';
        if (label) label.textContent = 'URL copied';
        setTimeout(function () {
          copyBtn.classList.remove('is-copied');
          if (label) label.textContent = orig;
        }, 1600);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done).catch(function () {
          window.prompt('Copy link:', url);
        });
      } else {
        window.prompt('Copy link:', url);
      }
    }
  });
 
  if (favFilterBtn) {
    favFilterBtn.addEventListener('click', function () {
      filtering = !filtering;
      refresh();
    });
  }
 
  refresh();
})();